<template>
  <section :class="[$mq.phone ? 'bg-white' : 'bg-gray']">
    <section class="container px-1 py-2 p-lg-3">
      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0">
          <div id="start-booking-form" :class="{'card shadow-sm': !$mq.phone}">
            <div class="my-4" :class="{'card-body': !$mq.phone}">
              <section class="section-booking">
                <!-- New booking form -->
                <div class="row">
                  <div class="col-12">
                    <h3 class="booking-title text-center">
                      {{ $t('message.menu.search_professionals') }}
                    </h3>
                    <div class="text-center">{{ $t('message.booking.new_booking.scroll_down_see_detail') }}</div>
                  </div>

                  <!-- Service types -->
                  <div class="col-12 mt-4">
                    <div class="form-group">
                      <h4>{{ $t('message.booking.new_booking.choose_a_service') }}</h4>
                      <div class="select-jumbo mb-3">
                        <select class="form-control" v-model="parentServiceId" @change="setParentService">
                          <option :value="item.id" v-for="item in availableServices">
                            {{ getService(item.id) | multiLangName }}
                          </option>
                        </select> 
                      </div>
                    </div> 
                  </div>

                  <!-- Forms places and province -->
                  <div class="col-12 mt-4">
                    <div class="form-group">
                      <h4 class="pb-2">{{ $t('message.booking.booking_step.my_place') }}</h4>
                      <div class="select-jumbo mb-3" v-if="user && state.userPlaces">
                        <select v-model="selectedUserPlaceId" @change="syncUserPlaceData">
                          <option :value="null">
                            {{ $t('message.booking.booking_step.please_select') }}
                          </option>
                          <option :value="userPlace.id" v-for="userPlace in filteredUserPlaces">
                            {{ userPlace.place_name }}
                          </option>
                        </select>
                      </div>
                      
                      <div class="select-jumbo">
                        <select v-model="selectedProvinceId" @change="setProvinceId">
                          <option :value="sortedCities[index].id" v-for="city, index in sortedCities"
                                  v-if="sortedCities[index].id > 0">
                           {{ city | multiLangName }} 
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Cleaning Service -->
                  <div class="col-md-12 mt-4" v-if="parentServiceId === 1">
                    <div class="form-group mb-2">
                      <h4 class="pb-2">{{ $t('message.booking.booking_step.accommodation') }}</h4>
                      <div class="select-jumbo">
                        <select v-model="selectedPlaceSize" @change="setWorkHour">
                          <option :value="sortedPlaceSizes[index].id" v-for="placeSize, index in sortedPlaceSizes">
                            {{ placeSize | multiLangName }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <label class="text-primary pl-1">
                      {{ $t('message.booking.booking_step.recommend') }}&nbsp;{{ $t(globalState.durations[selectedPlaceSize]) }}
                    </label>
                    <div class="select-jumbo mt-2">
                      <select v-model="selectedWorkHour">
                        <option :value="index" v-for="workHour, index in globalState.workHours">
                          {{ $t(workHour) }}
                        </option>
                      </select>
                    </div>
                    <div class="mt-2 pl-1 text-orange">
                      * {{ $t('message.booking.new_booking.excluding_break_time') }}
                    </div>
                  </div>

                  <!-- Ac cleaning service -->
                  <div class="col-md-12 mt-4" v-else-if="hasServiceItems">
                    <div class="d-flex justify-content-start align-items-center">
                      <div class="flex-fill">
                        <h4>{{ $t('message.service_item.select') }}</h4>
                      </div>
                      <div v-if="serviceItems">
                        <a href="" class="text-info" @click.prevent="clearSelectedServiceItems()">
                          {{ $t('message.service_item.clear') }}
                        </a>
                      </div>
                    </div>
                    <div class="card pointer-item mb-1" 
                      :class="[errorServiceItems ? 'border-danger' : 'border-divider']"
                      @click="openServiceItemModal()">
                      <div class="card-body">
                        <div class="d-flex justify-content-start align-items-center" v-if="!serviceItems">
                          <div><img :src="parentService.icon_url" width="24"/></div>
                          <div class="flex-fill px-3">{{ $t('message.service_item.select') }}</div>
                          <div><i class="fal fa-plus-circle text-info fa-lg"></i></div>
                        </div>
                        <div class="d-flex justify-content-start align-items-top" v-else>
                          <div>
                            <img :src="parentService.icon_url" width="32" class="active-svg-icon"/>
                          </div>
                          <div class="flex-fill px-3">
                            <div class="mb-2"><strong>{{ $t('message.service_item.selected_list') }}</strong></div>
                            <div v-for="serviceItem in serviceItems">
                              {{ serviceItem | multiLangName }}: {{ serviceItem.count }} {{ serviceItem.item_unit | multiLangName }}
                            </div>
                            <div class="text-info text-small mt-2">{{ $t('message.service_item.remark') }}</div>
                          </div>
                          <div>
                            <button class="btn btn-outline-info rounded-pill">{{ $t('message.button.edit') }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="errorServiceItems" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
                  </div>
                 
                  <!-- Other services -->
                  <div class="col-md-12 mt-4" v-else>
                    <div class="form-group">
                      <h4 class="pb-2" v-if="parentService && parentService.child_services_text">
                        {{ ($i18n.locale === 'th') ? parentService.child_services_text.title_th : parentService.child_services_text.title_en }}
                      </h4>
                      <div class="select-jumbo">
                        <select v-model="selectedServiceId" @change="updateServiceData">
                          <option :value="childServices[index].id" v-for="service, index in childServices">
                            {{ service | multiLangName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.row -->

                <!-- Forms date and time -->
                <div class="row mt-4">
                  <div class="col-12">
                    <h4 class="pb-2">{{ $t('message.booking.new_booking.pick_a_date') }}</h4>
                  </div>
                  <div class="col-6 pr-2">
                    <div class="form-group">
                      <input type="text"
                             :placeholder="$i18n.t('message.booking.booking_step.date')"
                             class="form-control -date-picker input-jumbo"
                             :class="{'form-alert': errorServiceDate}"
                             v-pikadayBooking="calendarData"
                             ref="cleaningDate"
                             readonly>
                      <span class="far fa-calendar-alt input-text-icon"></span>
                    </div>
                    <div v-if="errorServiceDate" class="form-alert-text -status-alert">{{ $t('message.booking.new_booking.date_is_required') }}</div>
                  </div>
                  <div class="col-6 pl-2">
                    <div class="form-group">
                      <div class="select-jumbo" :class="{'form-alert': errorServiceTime}">
                        <select style="background: white;" v-model="selectedTime">
                          <option :value="null">{{ $t('message.booking.new_booking.time') }}</option>
                          <option :value="time" v-for="time in filteredTimes">{{ time }}</option>
                        </select>
                        <span class="far fa-clock input-text-icon"></span>
                      </div>
                    </div>
                    <div v-if="errorServiceTime" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
                  </div>

                  <div class="col-12">
                    <div class="pl-1">
                      {{ $t('message.booking.booking_step.booking_today_remark') }}
                      <a href="https://line.me/R/ti/p/@BeNeat" target="_blank">
                        Line: @BeNeat
                      </a>
                      {{ $t('message.my_reservations.or') }}
                      <a href="https://www.facebook.com/beneatco/inbox/" target="_blank">
                        Facebook Messenger
                      </a>
                    </div>
                  </div>

                  <div class="col-12">
                    <hr>
                    <div class="d-flex justify-content-start align-items-center">
                      <div class="flex-fill">
                        <label class="text-dark">
                          {{ $t('message.booking.new_booking.subtotal') }}
                        </label>
                      </div>
                      <div class="flex-fill text-right">
                        <h3 class="text-primary">
                          {{ totalPrice | currency }}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 text-center mt-4">
                    <button class="button button-large button-block -cyan"
                            @click="goToChooseCleanerStep">
                      {{ $t('message.booking.booking_step.find_a_cleaner') }}
                    </button>
                  </div>
                </div>
                <!-- /.row -->

              </section>
              <!-- /.section-when -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="state.currentStep === 1">
      <hr class="mx-3 mt-0 mb-4" v-if="$mq.phone">
      <booking-detail v-if="selectedServiceId === 1"/>
      <div class="row" v-else-if="selectedServiceId != 1 && parentService && parentService.detail_th">
        <div class="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0">
          <div class="card">
            <div class="card-body">
              <!-- Service detail -->
              <div v-html="($i18n.locale === 'th') ? parentService.detail_th : parentService.detail_en"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Service items modal -->
    <service-item-modal v-if="hasServiceItems" 
                        ref="serviceItemModal"
                        :parentService="parentService"
                        @selectServiceItems="setServiceItems"/>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment-timezone'
  import BookingDetail from '../components/BookingDetail'
  import ServiceItemModal from '../components/ServiceItemModal'
  import insiderHelpers from '../../../helpers/insiderHelpers'
  import provinceHelpers from '../../../helpers/provinceHelpers'
  import serviceHelpers from '../../../helpers/serviceHelpers'
  import timeHelpers from '../../../helpers/timeHelpers'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'

  export default {
    components: {
      BookingDetail,
      ServiceItemModal
    },
    data () {
      return {
        availableServices: [],
        parentServiceId: 1,
        parentService: null,
        childServices: null,
        selectedServiceId: 1,
        selectedUserPlaceId: null,
        selectedProvinceId: 1,
        selectedPlaceSize: 1,
        selectedWorkHour: '2.0',
        selectedDate: null,
        selectedTime: null,
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        calendarData: {
          date: null,
          isToday: false,
          sameDayBookingConfig: null,
          serviceId: null,
          provinceId: null
        },
        availableTimes: null,
        todayDate: null,
        initNextAvailableTime: null,
        serviceItems: null,
        totalPrice: 0.0,
        errorServiceDate: false,
        errorServiceTime: false,
        errorServiceItems: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        state: 'booking/getState',
        user: 'auth/getUser'
      }),
      hasServiceItems () {
        let hasServiceItems = null
        if (this.parentService && this.parentService.has_service_items) {
          hasServiceItems = this.parentService.has_service_items
        }
        return hasServiceItems
      },
      filteredTimes () {
        return this.globalState.arrTimes.filter((time) => {
          if (this.availableTimes && this.availableTimes.indexOf(time) !== -1) {
            return time
          }
        })
      },
      sortedCities () {
        let provinces = null
        provinces = this._.orderBy(this.globalState.cities, [this.sortBy], ['asc'])
        if (this.globalState.configData && this.globalState.configData.specific_service_provinces) {
          const serviceProvince = this.getServiceProvince()
          if (serviceProvince) {
            provinces = []
            for (const provinceId of serviceProvince.province_ids) {
              provinces.push(this.globalState.cities[provinceId])
            }
            provinces = this._.orderBy(provinces, [this.sortBy], ['asc'])
          }
        }
        return provinces
      },
      filteredUserPlaces () {
        let userPlaces = []
        if (this.state.userPlaces) {
          userPlaces = this.state.userPlaces
          if (this.globalState.configData && this.globalState.configData.specific_service_provinces) {
            const serviceProvince = this.getServiceProvince()
            if (serviceProvince) {
              userPlaces = []
              for (const userPlace of this.state.userPlaces) {
                if (serviceProvince.province_ids.includes(userPlace.province_id)) {
                  userPlaces.push(userPlace)
                }
              }
            }
          }
        }
        return userPlaces
      },
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      }
    },
    watch: {
      'calendarData.date' (val, oldVal) {
        if ((oldVal && val !== oldVal) || (val && oldVal === null)) {
          this.selectedDate = val
          this.errorServiceDate = false
          this.updateBookingDate(val)
        }
      },
      selectedTime () {
        if (this.selectedTime) {
          this.errorServiceTime = false
        }
      },
      selectedWorkHour () {
        this.calculateCost()
      },
      selectedProvinceId () {
        this.calendarData.provinceId = this.selectedProvinceId
        this.calendarData.date = null
        this.syncServiceData() // Case bathroom cleaning sync service price based on province id
        if (this.serviceItems) {
          this.clearSelectedServiceItems()
        }
        this.calculateCost()
      },
      selectedServiceId () {
        this.calculateCost()
      },
      selectedUserPlaceId () {
        this.calculateCost()
      },
      totalPrice () {
        if (this.totalPrice) {
          // Insider product page event
          const totalPrice = serviceHelpers.converStringToNumber(this.totalPrice)
          const productParams = {
            user: this.user,
            serviceId: this.selectedServiceId,
            provinceId: this.selectedProvinceId,
            totalPrice: totalPrice,
            bookingCountType: 'one_time',
            isNoDateTimeBooking: false
          }
          insiderHelpers.productViewEvent(productParams)
        }
      }
    },
    methods: {
      getService (serviceId) {
        return this.globalState.services[serviceId]
      },
      getServiceProvince () {
        const serviceProvince = this.globalState.configData.specific_service_provinces.find(data => {
          if (data.service_id === this.parentServiceId) {
            return data
          }
          return null
        })
        return serviceProvince
      },
      setParentService (event) {
        this.parentServiceId = Number(event.target.value)
        this.selectedUserPlaceId = null
        // Clear service items
        this.serviceItems = null
        this.errorServiceItems = false
        this.syncServiceData()
        this.checkSelectedWorkHour()
      },
      checkSelectedWorkHour () {
        if (this.parentServiceId === 1) {
          const allWorkHours = Object.keys(this.globalState.workHours)
          // if not includes work hours
          if (!allWorkHours.includes(this.selectedWorkHour)) {
            this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
          }
        }
      },
      setWorkHour () {
        this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
        // If my place has work our then adopt it with my place selection
        if (this.state.userPlaceWorkHours[this.selectedUserPlaceId]) {
          this.selectedWorkHour = this.state.userPlaceWorkHours[this.selectedUserPlaceId]
        }
      },
      setCleaningDate () {
        const date = new Date()
        let dateValue = null
        if (this.calendarData.isToday) {
          dateValue = moment(date)
        } else {
          dateValue = moment(date).add(0, 'days')
        }
        dateValue = dateValue.format('DD/MM/YYYY')
        this.$refs.cleaningDate.value = dateValue

        if (this.preBookingData) {
          this.$refs.cleaningDate.value = this.preBookingData.cleaning_date
        }

        this.calendarData.date = this.$refs.cleaningDate.value
      },
      goToChooseCleanerStep () {
        let isValid = true
        if (this.globalState.services[this.parentServiceId].has_service_items && !this.serviceItems) {
          this.errorServiceItems = true
          isValid = false
        }
        if (!this.selectedDate) {
          this.errorServiceDate = true
          isValid = false
        }
        if (!this.selectedTime) {
          this.errorServiceTime = true
          isValid = false
        }
        if (isValid) {
          this.setPrebookingData()
        }
      },
      setPrebookingData () {
        const preBookingData = {
          service_id: this.selectedServiceId,
          user_place_id: this.selectedUserPlaceId,
          user_place: null,
          province_id: this.selectedProvinceId,
          cleaning_date: this.$refs.cleaningDate.value,
          cleaning_time: this.selectedTime,
          work_hour: this.selectedWorkHour,
          init_work_hour: this.selectedWorkHour,
          place_size_id: this.selectedPlaceSize,
          email: ''
        }
        if (this.selectedUserPlaceId && this.state.userPlaces) {
          for (const userPlace of this.state.userPlaces) {
            if (userPlace.id === this.selectedUserPlaceId) {
              preBookingData.user_place = userPlace
              break
            }
          }
        }
        // Set service items
        if (this.serviceItems) {
          preBookingData.service_items = this.serviceItems
          let workHours = 0.0
          for (const serviceItem of this.serviceItems) {
            if (serviceItem.duration_conditions) {
              workHours += serviceHelpers.getServiceItemDuration(serviceItem.count, serviceItem)
            } else if (serviceItem.duration) {
              workHours += serviceItem.count * serviceItem.duration
            }
          }
          preBookingData.work_hour = workHours
          preBookingData.init_work_hour = workHours
        }
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)
        this.clearOldBookingData()
        // Go to choose a cleaner
        this.$router.push('/booking/choose-cleaner')
      },
      clearOldBookingData () {
        // console.log('Clear data at booking step')
        // Remove selected cleaner
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
        // Remove new order data
        // this.$store.commit('booking/SET_NEW_ORDER_DATA', null)
        // Remove preCheckoutData
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        // Remove promo code
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        // Remove extras
        this.$store.commit('extras/SET_APPLIED_EXTRAS', null)
        this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', false)
      },
      checkChildServicesHasNoProvinceId () {
        const services = this.globalState.services
        for (let key in services) {
          const service = services[key]
          if (service.parent_id === this.parentServiceId) {
            if (!service.province_id) {
              return true
            }
          }
        }
        return false
      },
      syncServiceData () {
        // Set parent service
        this.parentService = this.globalState.services[this.parentServiceId]
        if (this.parentServiceId === 1) {
          this.selectedServiceId = 1
          if (this.user) {
            this.syncUserPlaceData()
          }
        } else if (this.parentService.has_service_items) {
          this.selectedServiceId = this.parentService.id
        } else {
          if (!this.checkChildServicesHasNoProvinceId()) {
            if (!this.selectedProvinceId) {
              this.selectedProvinceId = 1
            }
          }
          // Check below condition to prevent selected province id available in some service but when selecting other service does not have the province id of it
          if (this.selectedProvinceId && !this.sortedCities.find(province => province.id === this.selectedProvinceId)) {
            this.selectedProvinceId = this.sortedCities[0].id
          }
          this.selectedServiceId = null
          this.childServices = []
          const datas = this.globalState.services
          let i = 0
          for (let key in datas) {
            const service = datas[key]
            if (service.parent_id === this.parentServiceId) {
              // Bathroom cleaning child services based on province
              if ((service.province_id === 0 || this.selectedProvinceId === service.province_id)) {
                this.childServices[i] = {
                  id: service.id,
                  parent_id: service.parent_id,
                  name_th: service.name_th,
                  name_en: service.name_en,
                  duration: service.duration,
                  cost: service.cost
                }
                i += 1
              }
            }
          }
          if (this.childServices.length) {
            this.selectedServiceId = this.childServices[0].id
          }
          this.updateServiceData()
        }
      },
      updateServiceData () {
        const serviceData = serviceHelpers.getServiceData(this.globalState.services, this.selectedServiceId)
        if (serviceData && serviceData.duration) {
          this.selectedWorkHour = serviceData.duration
        }
      },
      syncUserPlaceData () {
        if (this.state.userPlaces && this.selectedUserPlaceId) {
          this.selectedProvinceId = this.state.userPlaceCities[this.selectedUserPlaceId]
          this.selectedPlaceSize = this.state.userPlaceSizes[this.selectedUserPlaceId]
          this.setWorkHour()
        } else {
          this.selectedProvinceId = 1
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }
      },
      setProvinceId (event) {
        this.selectedProvinceId = Number(event.target.value)
        // If change new city reset form values to default
        if (this.state.userPlaceCities && Number(event.target.value) !== this.state.userPlaceCities[this.selectedUserPlaceId]) {
          // Reset form
          this.selectedUserPlaceId = null
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }
      },
      setAvailableTimes (nextAvailableTime) {
        const arrTimes = this.globalState.arrTimes

        this.availableTimes = []
        if (nextAvailableTime) {
          let startIndex = arrTimes.indexOf(nextAvailableTime)

          if (startIndex < 8) {
            startIndex = 8
          }
          for (let i = startIndex; i < arrTimes.length; i++) {
            this.availableTimes.push(arrTimes[i])
          }
          this.selectedTime = this.availableTimes[0]
        } else {
          this.availableTimes = arrTimes
        }
      },
      updateBookingDate (selectedDate) {
        let nextAvailableTime = null
        if (selectedDate === moment().format('DD/MM/YYYY')) {
          nextAvailableTime = timeHelpers.getNextAvailableTime()
        }
        this.setAvailableTimes(nextAvailableTime)
      },
      setServiceItems (serviceItems) {
        if (serviceItems) {
          this.serviceItems = []
        }
        this.serviceItems = serviceItems
        this.calculateCost()
        this.errorServiceItems = false
      },
      openServiceItemModal () {
        this.$refs.serviceItemModal.showModal(true, Number(this.selectedProvinceId))
      },
      clearSelectedServiceItems () {
        this.serviceItems = null
        this.$refs.serviceItemModal.clearData()
      },
      calculateCost () {
        if (this.parentServiceId === 1) {
          const costPerHour = Number(this.globalState.provinceWages[this.selectedProvinceId].cost_per_hour)
          const workHour = Number(this.selectedWorkHour)
          let totalPrice = costPerHour * workHour
          const discount = provinceHelpers.getProvinceDiscount(this.globalState.provinceDiscounts, this.selectedProvinceId, this.selectedWorkHour)
          if (discount) {
            let discountCost = (totalPrice * discount) / 100
            discountCost = Math.round(discountCost * 100) / 100
            totalPrice = totalPrice - discountCost
          }
          this.totalPrice = totalPrice
          this.totalPrice = serviceHelpers.converStringToNumber(this.totalPrice)
        } else {
          if (!this.selectedServiceId || this.hasServiceItems) {
            this.totalPrice = 0.0
          }
          if (this.childServices) {
            for (let key in this.childServices) {
              const service = this.childServices[key]
              if (service.id === this.selectedServiceId) {
                this.totalPrice = service.cost
                break
              }
            }
          }
          if (this.serviceItems) {
            this.totalPrice = serviceHelpers.getTotalPriceOfServiceItems(this.serviceItems)
          }
          this.totalPrice = serviceHelpers.converStringToNumber(this.totalPrice)
        }
      }
    },
    mounted () {
      if (this.preBookingData) {
        this.$refs.cleaningDate.value = this.preBookingData.cleaning_date
      }

      this.parentServiceId = 1
      this.syncServiceData()

      // Check service
      if (this.$route.query.sid) {
        this.parentServiceId = parseInt(this.$route.query.sid)
        this.syncServiceData()
      }

      // Load global data to config disable same day booking
      this.calendarData.sameDayBookingConfig = serviceHelpers.formatSameDayData(this.globalState.configData.same_day_booking)
      this.calendarData.serviceId = this.parentServiceId
      this.calendarData.provinceId = this.selectedProvinceId

      // Save user event log
      userEventLogHelpers.logEvent('begin_booking', {
        service_id: this.parentServiceId
      })
      // Set available times
      this.setAvailableTimes(null)
      // Set today date
      this.todayDate = moment().format('DD/MM/YYYY')
      // Calculate service cost
      this.calculateCost()
    },
    created () {
      // this.initNextAvailableTime = timeHelpers.getNextAvailableTime()
      this.$store.commit('booking/SET_BOOKING_CURRENT_STEP', 1)

      if (this.user) {
        const queryUserPlaceData = {
          user_id: this.user.id,
          province_id: 0
        }
        this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
      }

      // Check prebooking data
      if (this.preBookingData) {
        this.selectedServiceId = this.preBookingData.service_id
        this.selectedUserPlaceId = this.preBookingData.user_place_id
        this.selectedDate = this.preBookingData.cleaning_date
        this.selectedTime = this.preBookingData.cleaning_time
        this.selectedProvinceId = this.preBookingData.province_id
        this.selectedPlaceSize = this.preBookingData.place_size_id
        this.selectedWorkHour = this.preBookingData.work_hour
        this.email = this.preBookingData.email

        this.checkSelectedWorkHour()

        if (this.selectedUserPlaceId) {
          this.setWorkHour()
        }

        this.calendarData = {
          date: this.preBookingData.cleaning_date,
          isToday: this.calendarData.isToday
        }

        // Set service parent id
        this.parentServiceId = (this.selectedServiceId === 1) ? 1 : 2
      } else {
        this.calendarData = {
          date: null,
          isToday: this.calendarData.isToday
        }
      }

      // Set available services
      const services = this.globalState.services
      for (let key in services) {
        if (services[key].service_type === 'popular' && !services[key].is_special_service) {
          this.availableServices.push(services[key])
        }
      }
    }
  }
</script>

<style scoped>
  .input-text-icon {
    float: right;
    margin-right: 1rem;
    margin-top: -2.15rem;
    position: relative;
    font-size: 120%;
    z-index: 2;
    color: #9E9E9E;
  }
  div >>> ul {
    padding-left: 1.2rem;
  }
  div >>> ol {
    padding-left: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/steps/Booking.vue